<div class="tabs-container">
    <ul class="nav nav-tabs justify-content-center">
      <li class="nav-item" *ngFor="let tab of tabs">
        <a 
          class="nav-link"
          [class.active]="selectedData === tab.value"
          (click)="selectedDataChange(tab.value)">
          {{ tab.label }}
        </a>
      </li>
    </ul>
  </div>
  
  <!-- MQTT Connection status -->
  <div *ngIf="isConnecting" class="connection-status text-center">
    <div class="spinner-border text-primary" role="status"></div>
    <p>Connected to MQTT broker. Awaiting data...</p>
  </div>
  
  <!-- Chart Grid -->
  <div class="container-fluid mt-3">
    <div class="row">
      <div class="col-md-6 col-xl-4 mb-4" *ngFor="let key of chartKeys; let i = index">
        <div #chartRef class="chart-box shadow-sm rounded bg-white p-2"></div>
      </div>
    </div>
  </div>
  